import { FunctionComponent } from 'react'
import styles from './childWithoutSection.module.scss'
import Dialog from '@/components/_custom/Dialog/Dialog'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import { useTranslation } from 'react-i18next'

interface ChildWithoutSectionProps {
    open: boolean
    handleClose: () => void
}

const ChildWithoutSection: FunctionComponent<ChildWithoutSectionProps> = ({ open, handleClose }) => {
    const { t } = useTranslation()

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('information')} parent />
            <DialogBody className={styles.DialogBody}>
                <div className={styles.Container}>
                    <p className={styles.Text}> {t('waitChildWithoutSection1')} </p>
                    <p className={styles.Text}> {t('waitChildWithoutSection2')} </p>
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'close'} onClick={handleClose} parent className={styles.Button} />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ChildWithoutSection
